(function () {
    'use strict';
    angular
        .module('app')
        .controller('confirmDialogController', confirmDialogController);

    function confirmDialogController($uibModal, $uibModalInstance, config, $rootScope, blockUI) {
        var vm = this;
        //==Main==
        onInit();
        //========

        function onInit() {
            vm.data = dataInit();
            vm.view = viewInit();
            vm.event = eventInit();
            vm.style = styleInit();
            //=========
            vm.view.hasTitle = (!!vm.data.confirmTitle);
            vm.view.hasContent = (!!vm.data.confirmContent);
            vm.style.titleStyle = { padding: '10px', 'word-break': 'break-word' };
            vm.style.contentStyle = { padding: '10px', 'word-break': 'break-word' };
            vm.style.footerStyle = { padding: '10px', 'word-break': 'break-word' };
            vm.isBusy = false;
        }
        function dataInit() {
            config = config || {};
            //=====
            var result = {
                confirmTitle: config.confirmTitle || '',//..........................................詢問標題
                confirmContent: config.confirmContent || '',//......................................詢問內容
                textButtonOk: config.textButtonOk || $rootScope.translate.tsunButtonConfirmOk,//....確認按鈕文字
                textButtonCancel: config.textButtonCancel || $rootScope.translate.commonCancel,//...取消按鈕文字
                promiseAction: config.promiseAction //...動作
            };
            return result;
        }
        function viewInit() {
            var result = {
                hasTitle: false,//......是否有標題
                hasContent: false,//....是否有內容
            };
            return result;
        }
        function eventInit() {
            var result = {
                ok: ok,//.........確認詢問事件，回傳true
                cancel: cancel,//.拒絕詢問事件，回傳false
            };
            return result;
        }
        function styleInit() {
            var result = {
                bodyStyle: {},//.........整個畫面的風格
                titleStyle: {},//........標題的風格
                contentStyle: {},//......內容的風格
                footerStyle: {},//.......尾段的風格
            };
            return result;
        }
        //=========
        function ok() {

            if (vm.data.promiseAction) {
                vm.isBusy = true;
                vm.data.promiseAction().then(() => {
                    $uibModalInstance.close(true);
                })
            } else {
                $uibModalInstance.close(true);
            }

        }
        function cancel() {
            $uibModalInstance.close(false);
        }
    }
})();